// Read an EXPLAIN plan and decide if a filtered query is too risky to send.
//
// :4902 is a shared node. A scan of cvr (2.2 million documents) blocks it for
// minutes. The JSON search box can filter on any field, so the site asks for
// the plan first. The plans below are DIRECTLY OBSERVED on :4902, 2026-09-13:
//
//   WHERE _searchnames = 'x'                   index scan (prefix), pk lookup
//   WHERE virksomhedsformkort = 'APS' LIMIT 26 full scan, filter
//   ... ORDER BY sidstOpdateret DESC LIMIT 26  index-ordered scan, filter
//
// The last plan stops after 26 matches. For a rare value, it walks the whole
// sort index before it finds them, so it is refused too.
//
// kinedb 796d9006 (B882) plans an indexed filter with a sort as
// `index scan (prefix), index-ordered scan ... over the candidates, filter`
// (cvr.kinedb.com, 2026-09-16). `holding aps` sorted by sidstOpdateret ran for
// more than 60 s, so the site sends that search without the sort.

/** True when an index scan feeds a walk of the sort index (the B882 plan). */
export function candidateWalk(steps) {
  const operations = (steps ?? []).map((s) => s.operation);
  return operations.some((o) => o.startsWith('index scan')) && operations.includes('index-ordered scan');
}

/** A reason to refuse the plan, or null when the plan is index-served. */
export function scanRefusal(steps) {
  const operations = (steps ?? []).map((s) => s.operation);
  if (operations.includes('full scan')) {
    return 'kinedb has no index for this filter, so it would scan the whole collection. The site does not send that query.';
  }
  if (candidateWalk(steps)) return null;
  if (operations.includes('index-ordered scan') && operations.includes('filter')) {
    return 'kinedb has no index for this filter, so it would walk the sort index and test each row. The site does not send that query.';
  }
  return null;
}
